import { useCallback, useEffect, useState } from "react";
/**
 * General Helpers
 */
export const trimThisDown = (text, limit) => {
    return text.length > limit ? text.substring(0, limit) + '...' : text;
};
export const getExtension = (name) => {
    let nameSplit = name.split('.')
    let ext = nameSplit[1].toLowerCase()
    if (ext == 'pdf') {
        return 'pdf'
    } else if (ext == 'wav' || ext == 'm4a' || ext == 'mp3' || ext == 'mp4') {
        return 'audio'
    } else {
        return 'image'
    }
}

export function numberFormat(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

export const getUrlParam = () => {
    var vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}


export const makeURL = (text) => {
    var urlRegex = new RegExp(
        '([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?',
        'g'
    );
    return text.replace(urlRegex, (url) => {
        if (url.search(/^http[s]?\:\/\//) === -1) {
            return 'https://' + url;
        } else {
            return url;
        }
    });
}

export function changeColorOpacity(color, opacity) {
    const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    const rgbRegex = /^rgb(a)?\(\s*((25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\s*,\s*){2}(25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\s*(,\s*\d+(\.\d+)?)?\)$/i;
    const hslRegex = /^hsla?\(\s*((360|3[0-5]\d|[12]\d{2}|[1-9]\d|\d)\s*,\s*){2}(360|3[0-5]\d|[12]\d{2}|[1-9]\d|\d)\s*(,\s*\d+(\.\d+)?)?\)$/i;

    // IF HEX
    if (hexRegex.test(color)) {
        if (color.length > 7)
            color = color.substring(0, color.length - 2);
        const _opacity = Math.round(Math.min(Math.max(opacity, 0), 1) * 255);
        let opacityHex = _opacity.toString(16).toUpperCase()
        if (opacityHex.length == 1)
            opacityHex = "0" + opacityHex;
        return color + opacityHex;
    }
    // IF RGB OR RGBA
    else if (rgbRegex.test(color)) {
        if (color.substring(0, 4) === 'rgba') {
            return color.replace(/[^,]+(?=\))/, opacity)
        } else {
            return color.replace(')', ', ' + opacity + ')').replace('rgb', 'rgba')
        }
    } else {
        return color
    }

}